import React, { ReactNode } from "react";
import "./commonNav.scss";
function CommonNav({
  children,
  className,
}: {
  children?: ReactNode;
  className?: string;
}) {
  return <div className={`commonNav ${className}`}>{children}</div>;
}

export default CommonNav;
